import { config } from './config.js';

const normalizeHost = (host: string = '') => {
  let end = host.length;
  while (end > 0 && host[end - 1] === '/') end--;
  return host.slice(0, end);
};

export const productImageUrl = (
  resolutionSegment: string,
  imageUrl: string,
  format: 'jpg' | 'webp',
  host: string | undefined = config.imageHost,
) => `${normalizeHost(host)}/product_images/${resolutionSegment}${formatImageUrl(imageUrl, format)}`;

export const getPictureSourceSet = (
  imageUrl: string,
  fileFormat: 'jpg' | 'webp',
  host: string | undefined = config.imageHost,
) => `${productImageUrl('180x246p', imageUrl, fileFormat, host)} 120w,
    ${productImageUrl('287x393p', imageUrl, fileFormat, host)} 180w,
    ${productImageUrl('360x492p', imageUrl, fileFormat, host)} 287w,
    ${productImageUrl('435x596p', imageUrl, fileFormat, host)} 360w,
    ${productImageUrl('574x786p', imageUrl, fileFormat, host)} 435w,
    ${productImageUrl('870x1192p', imageUrl, fileFormat, host)} 574w`;

export const getSinglePictureUrl = (imageUrl: string, format: 'jpg' | 'webp', size = '180x246') =>
  productImageUrl(`${size}p`, imageUrl, format);

export const formatImageUrl = (imageUrl: string, format: 'jpg' | 'webp') => {
  const formattedImageUrl = format === 'webp' ? imageUrl.replace('.jpg', '.webp') : imageUrl;
  return formattedImageUrl.startsWith('/') ? formattedImageUrl : `/${formattedImageUrl}`;
};
